/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Return_To_Sorting_HintInputs */

const vi_warehouse_defects_return_to_sorting_hint = /** @type {(inputs: Warehouse_Defects_Return_To_Sorting_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sau khi xong kho phân loại có thể chuyển lô lỗi sang phân loại lại.`)
};

/**

* @param {Warehouse_Defects_Return_To_Sorting_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_return_to_sorting_hint = /** @type {((inputs?: Warehouse_Defects_Return_To_Sorting_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Return_To_Sorting_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_return_to_sorting_hint(inputs)
});